import { mockLaborCostCalc, mockMarketWageUnitPrice, mockOutputRatio, } from "./labor-cost.mocks";
import { rest } from "msw";
export const laborCostHandlers = [
    rest.get("/labor-cost", (_req, res, ctx) => {
        return res(ctx.status(200), ctx.json(mockLaborCostCalc));
    }),
    rest.get("/labor-current-unit-price", (_req, res, ctx) => {
        return res(ctx.status(200), ctx.json(mockMarketWageUnitPrice));
    }),
    rest.get("/cost-ratio", (_req, res, ctx) => {
        return res(ctx.status(200), ctx.json(mockOutputRatio));
    }),
];
